/*
 * File: SearchStudents.ts
 * Author: Austin Robinson
 * Date Created: 7/21/2023
 * Copyright (c) DrivingDoc 2023
 */

import { privateApi, ErrorResponse } from 'api';
import { createQuery } from 'react-query-kit';

export type SearchStudentsParams = string

export type SearchStudentsResult = {
    tenant_id: string,
    user_id: string,
    permit_num: string | null,
    permit_issued: string | null,
    permit_expiration: string | null,
    permit_restrictions: string | null,
    permit_endorsements: string | null,
    permit_created_at: string | null,
    permit_updated_at: string | null,
    medical_conditions: string | null,
    high_school: string | null,
    user: {
        tenant_id: string,
        id: string,
        title: string | null,
        first_name: string | null,
        middle_name: string | null,
        last_name: string | null,
        nickname: string | null,
        email: string | null,
        date_of_birth: string | null,
        sex: string | null,
        active: boolean,
        created_at: string | null,
        updated_at: string | null,
        created_by: string | null,
        updated_by: string | null,
        des_id: string | null,
    }
};

async function searchStudents(params: SearchStudentsParams | undefined): Promise<SearchStudentsResult[]> {
    if (params === undefined) {
        return [];
    }

    // make api call
    const result = await privateApi.post(`${import.meta.env.VITE_API_BASE_URL}/users/students/search`, {
        searchTerm: params
    });
    // return the data object
    return result.data as SearchStudentsResult[];
}

const useSearchStudents = createQuery<SearchStudentsResult[], SearchStudentsParams, ErrorResponse>({
    queryKey: ['search_students'],
    fetcher: (variables) => searchStudents(variables),
    initialData: [],
});

export { useSearchStudents, searchStudents };
